import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem } from 'primeng/api';
import { first } from 'rxjs';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-mi-consolidated-rejected-count-wise-report',
  templateUrl: './mi-consolidated-rejected-count-wise-report.component.html',
  styleUrls: ['./mi-consolidated-rejected-count-wise-report.component.scss']
})
export class MiConsolidatedRejectedCountWiseReportComponent implements OnInit {
  @Input() finyear: string;
  
  @ViewChild('dataTable') tableContainer: ElementRef;

  public subActionType: string = "RejectedApps";
  // public finYear: any;
  vendorCode:any;
  userType:any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miRejectedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;

  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Rejected Apps';
  miRejecetedReport: MenuItem[];
  loading: boolean;

  constructor(
    private reportsService: ReportsService,
    private router: Router,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    this.vendorCode=JSON.parse(sessionToken).officeCode;

    this.userType=JSON.parse(sessionToken).role;

    // this.finYear = 'All';
    // if(this.finYear == 'All'){
    //   this.finYear = '';
    // }

    this.loadMIDataUnderProcess(this.subActionType, 0);
    setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)

    this.miRejecetedReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.miTableDataWithFilter, `MI_${this.tableHeaderName}`);
        },
      },
    ];
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.AppID,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Current Level': d.Level_ID,
          'Current Action': d.ActionType,
          'Last Action Date': d.assigneddate,
          'Status': d.Status,
          'Pending Level': d.nextuser,
          'Pending Action': d.NextAction,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadMIDataUnderProcess(subActionType, autoId) {
    // this.loader.start();
    if (autoId == 0) {
      this.loading = true;
    }
    let sub = this.reportsService
      .getMIAggTabsUnProcessedAppsDrillDownNewVendor(this.finyear, subActionType,this.vendorCode,this.userType,autoId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.miTableData = data;
            this.miTableDataWithFilter = data;
            this.actionTypesFromTableData, this.miRejectedFilterList = this.getUniqueActionType(data);

            console.log(this.actionTypesFromTableData)
          }else{
            this.miTableData = [];
            this.miTableDataWithFilter = [];
            this.actionTypesFromTableData = [];
          }
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;
          this.miTableData = [];
          this.miTableDataWithFilter = [];
          this.actionTypesFromTableData = [];
        },
      });

      this.subscriptions.push(sub);
  }
  getUniqueActionType(data) {
    const actionLevelSet = new Set(data.map(entry => entry.nextuser));
    const actionLevelObjects = Array.from(actionLevelSet).map(actionLevel => ({ actionLevel }));
    
    return actionLevelObjects;
  }
  printForm(AppID) {
    
    if (AppID) {
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userId = JSON.parse(payload)?.sub;
      if(this.userId == 'admin'){
        this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'CAO'){
        this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'DD-EW'){
        this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userType== 'Vendor'){
        this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId== 'webadmin'){
        this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else {
        this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['department', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }
    }
  }


}
